import React from 'react';
import '../styles/ChordTypeLabel.css';

/**
 * Props
 * - type: string | string[]
 */
const ChordTypeLabel = ({ type }) => {
  if (!type) return null;

  const labelMap = {
    Diatonic: { text: 'Diatonic', className: 'label-diatonic' },
    'Secondary Dominant': { text: '2nd.Dom', className: 'label-sd' },
    'Substitute Dominant': { text: 'Subst.Dom', className: 'label-subst' },
    'Backdoor Dominant': { text: 'Backdoor', className: 'label-backdoor' },
    'Blackadder Code': { text: 'Blackadder', className: 'label-blackadder' },
    Parallel: { text: 'Parallel', className: 'label-parallel' },
    Triad: { text: 'Triad', className: 'label-triad' },
    Seventh: { text: '7th', className: 'label-seventh' },
  };

  const types = Array.isArray(type) ? type : [type];
  const labels = types.map(t => labelMap[t]).filter(Boolean);

  if (labels.length === 0) return null;

  return (
    <span className="chord-type-labels">
      {labels.map((label, idx) => (
        <span key={idx} className={`chord-type-label ${label.className}`}>
          {label.text}
        </span>
      ))}
    </span>
  );
};

export default ChordTypeLabel;
